// extracted by mini-css-extract-plugin
export default {"draftUploadHeading":"DraftUpload_draftUploadHeading__QT6BR"};